import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=bb7f23e2&scoped=true&"
var script = {}
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=bb7f23e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f23e2",
  null
  
)

export default component.exports